import Vue from 'vue'

const state = Vue.observable({
  notifications: [], // { id, type, title, error, failureReason, retryFn, loading, autoRetryCount, maxAutoRetry }
})

let _nextId = 1

// 这三种类型开启静默自动重试
const AUTO_RETRY_TYPES = new Set(['storyboard', 'video', 'dub'])
const MAX_AUTO_RETRY = 1
const AUTO_RETRY_DELAY = 2000 // ms

// 记录每个任务已静默重试的次数，key = type::title
const _silentCounts = {}

const failNotify = {
  state,

  /**
   * 添加一条失败通知
   *
   * storyboard / video / dub 类型在前 MAX_AUTO_RETRY 次调用时静默自动重试（不弹窗），
   * 重试全部失败后才真正弹出通知。
   *
   * @param {string} options.type  'video' | 'storyboard' | 'dub' | 'role' | 'scene' | 'prop'
   * @param {string} options.title 标题
   * @param {string} options.error 错误描述
   * @param {string} [options.failureReason] 失败原因（后端 failureReason 字段）
   * @param {Function} [options.retryFn] 重试回调
   * @returns {number} 通知 id（静默重试时返回 -1）
   */
  add({ type, title, error,failureReason, retryFn, retryLabel, retryIcon, loadingText }) {
    if (AUTO_RETRY_TYPES.has(type) && retryFn) {
      const key = type + '::' + title
      const count = _silentCounts[key] || 0

      if (count < MAX_AUTO_RETRY) {
        // 静默重试：不弹窗，2 秒后悄悄重试
        _silentCounts[key] = count + 1
        setTimeout(() => {
          try { retryFn() } catch (e) { /* 抛出的错误由业务侧的 failNotify.add 接管下一次 */ }
        }, AUTO_RETRY_DELAY)
        return -1
      }

      // 已达上限：清空计数，展示通知
      delete _silentCounts[key]
    }

    const id = _nextId++
    const maxAutoRetry = AUTO_RETRY_TYPES.has(type) ? MAX_AUTO_RETRY : 0
    state.notifications.push({
      id,
      type,
      title,
      error,
      failureReason: failureReason || null,
      retryFn: retryFn || null,
      retryLabel: retryLabel || null,
      retryIcon: retryIcon || null,
      loadingText: loadingText || null,
      loading: false,
      autoRetryCount: maxAutoRetry, // 到这里说明已静默重试过 maxAutoRetry 次
      maxAutoRetry,
    })
    return id
  },

  remove(id) {
    const idx = state.notifications.findIndex(n => n.id === id)
    if (idx !== -1) state.notifications.splice(idx, 1)
  },

  setLoading(id, loading) {
    const n = state.notifications.find(n => n.id === id)
    if (n) Vue.set(n, 'loading', loading)
  },

  removeAll() {
    state.notifications.splice(0, state.notifications.length)
  },
}

export default failNotify
